import { render, staticRenderFns } from "./draft_note.vue?vue&type=template&id=471314e0&"
import script from "./draft_note.vue?vue&type=script&lang=js&"
export * from "./draft_note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "draft_note.vue"
export default component.exports